import SectionTestimonials from "components/SectionTestimonials/SectionTestimonials";
import SectionHero from "components/SectionHero/SectionHero";
import WhyChooseUs from "components/WhyChooseUS/WhyChooseUs";
import { useEffect } from "react";
import RentalPolicies from "components/FAQs/FAQs";
import SectionAbout from "containers/PageAbout/SectionAbout";
import { useData } from "data/data-provider";
import SectionGridAllFleet from "./SectionGridAllFleet";

function PageHome() {
  const { aboutUs, whyUs, testimonials, faqs, ourVehicles } = useData();

  useEffect(() => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  return (
    <>
      <div className="lg:container sm:py-2 sm:mt-5 relative">
        <SectionHero className="mb-16" />
        <div className="container relative" style={{ padding: "0px" }}>
          <div id="section">
            {ourVehicles?.length > 0 && (
              <div className="container relative mb-16 sm:px-0">
                <SectionGridAllFleet />
              </div>
            )}
            {aboutUs && (
              <div className="container mb-16 sm:px-0">
                <SectionAbout aboutUs={aboutUs} />
              </div>
            )}
            {(whyUs?.heading || whyUs?.description || whyUs?.image_url) && (
              <div className="container mb-16 sm:px-0">
                <WhyChooseUs />
              </div>
            )}
            {(testimonials?.heading || testimonials?.keypoints?.length > 0) && (
              <div className="container mb-16 mt-16 sm:px-0">
                <SectionTestimonials uniqueClassName="PageAbout_" />
              </div>
            )}
          </div>
        </div>
        {(faqs?.heading ||
          faqs?.description ||
          faqs?.keypoints?.length > 0) && (
          <div className="container relative py-16">
            <RentalPolicies />
          </div>
        )}
      </div>
    </>
  );
}

export default PageHome;
